/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/GridTable/StyleConstant';
import { NumberAlongAlphabetComparator } from '../../../../../SharedModules/utilities/utilities';

export const letterTemplateTableHead = [
    {
    headerName:'Version',
    field: 'templateVersion',
    editable: false,
    hide:true,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_120,
    maxWidth: Styles.Width_120,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template ID',
    field: 'templateId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_170,
    // maxWidth: Styles.Width_170,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_300,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'TemplateNameCell',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    comparator: NumberAlongAlphabetComparator,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Description',
    field: 'descr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 4,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_300,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'DescriptionCell',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Version',
    field: 'templateVersion',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_120,
    maxWidth: Styles.Width_120,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const letterTemplateTableHead1 = [
    {
    headerName: 'Version',
    field: 'templateVersion',
    editable: false,
    sortable: true,
    hide:true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_120,
    maxWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template ID',
    field: 'templateId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_170,
    // maxWidth: Styles.Width_160,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_230,
    // maxWidth: Styles.Width_250,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'TemplateNameCell1',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Description',
    field: 'descr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_300,
    // maxWidth: Styles.Width_250,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'DescriptionCell1',
    cellClass: 'frr-ellipsis-text',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Version',
    field: 'templateVersion',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_120,
    maxWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const WindowAddressTableHead = [
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_170 + Styles.Width_5,
    maxWidth: Styles.Width_170 + Styles.Width_20,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template Type',
    field: 'templateTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_160 + Styles.Width_5,
    maxWidth: Styles.Width_160 + Styles.Width_20,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Template Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_250,
    // maxWidth: Styles.Width_250,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'TemplateNameCell1',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Window Address Position',
    field: 'windowAddrPos',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    // maxWidth: Styles.Width_200 + Styles.Width_50,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const letterTemplateHead = [
  {
    headerName: 'Display Name',
    field: 'displayName',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Actions',
    field: 'actions',
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionMergeCell',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    sortable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const mergeFieldTemplateHead = [
  {
    headerName: ' Merge ID',
    field: 'templateMetaDataSeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_80,
    maxWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'description',
    editable: false,
    sortable: true,
    columnSpan: 2,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Display Order',
    field: 'displayOrder',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_80,
    maxWidth: Styles.Width_170,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const subMergeFieldTemplateHead = [
  {
    headerName: 'Select',
    field: 'isSelected',
    cellRenderer: 'CheckboxCell',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_50,
    maxWidth: Styles.Width_80 - Styles.Width_5,
    cellClass: 'ag-cell-checkbox',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'left',
    },
  },
  {
    headerName: 'ID',
    field: 'templateMetaDataSeqNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_85,
    maxWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'columnHeading',
    editable: false,
    sortable: true,
    columnSpan: 3,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_300,
    // maxWidth: Styles.Width_170,
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Display Order',
    field: 'displayOrder',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_160,
    maxWidth: Styles.Width_170,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Order',
    field: 'orderNum',
    editable: false,
    sortable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_100 - Styles.Width_5,
    maxWidth: Styles.Width_100,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Sort',
    field: 'isSort',
    cellRenderer: 'SortCheckboxCell',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_50,
    maxWidth: Styles.Width_85 - Styles.Width_20,
    cellClass: 'ag-cell-checkbox',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'left',
    },
  },
  {
    headerName: 'Order Type',
    field: 'orderType',
    cellRenderer: 'SelectCheckboxCell',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    maxWidth: Styles.Width_150,
    cellClass: 'ag-cell-checkbox frr-ag-cell-order-type',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'left',
    },
  },
];

export const mfgHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
